import axios from 'axios';
import {
  FETCH_CONTENT_RESPONSE,
  FETCH_CONTENT_RESPONSE_PRIMARY,
  FETCH_CONTENT_ERROR,
  BUILD_CONTENT,
  FETCH_INITIAL_STATE
} from './types';

export const fetchContentAction = (
  contentUrl,
  page,
  primary = false
) => dispatch => {
  axios
    .get(contentUrl)
    .then(function (response) {
      dispatch({
        type: primary ? FETCH_CONTENT_RESPONSE_PRIMARY : FETCH_CONTENT_RESPONSE,
        payload: { ...response, page: page }
      })
    })
    .catch(function (error) {
      dispatch({ type: FETCH_CONTENT_ERROR, payload: error })
    })
};

export const buildContentAction = (data, page) => ({
  type: BUILD_CONTENT,
  payload: { page, data }
})

// For local testing only
export const fetchInitialContent = dataURL => dispatch => {
  axios
    .get(dataURL)
    .then(response => {
      dispatch({
        type: FETCH_INITIAL_STATE,
        payload: response.data
      })
    })
    .catch(error => console.log('Error fetching initial state', error))
};



// WEBPACK FOOTER //
// ./src/services/content/actions.js